export const GET_STARTED_PAGE = {
  eyebrow: "EAZYBOT SETUP GUIDE",
  heading: "Getting Started is Easy",
  sub: "Our Step-by-Step Video Setup Guide makes it easy for you to put your digital employees to work. If you need assistance, send us an email and we'll schedule a one-on-one Zoom with you and a member of our Setup Team.",
  steps: [
    {
      no: "01", icon: "bot",
      title: "Create Your EazyBot Account",
      body: "Get an EazyBot registration link from the person who referred you to this information.",
      videos: [],
    },
    {
      no: "02", icon: "wallet",
      title: "Setup Your Coinbase or Kraken Account",
      note: "*If you already have a Coinbase or Kraken account, go to the next step.",
      body: "Find the Coinbase or Kraken App in your phone's app store, then download it and follow the steps to setup a new account. We recommend creating your accounts on your phone because you'll need your camera to complete the account verification process. Once your account is set up, you can log in from your computer.",
      videos: [],
    },
    {
      no: "03", icon: "banknote",
      title: "Add Funds to Your Coinbase or Kraken Account",
      note: "*If you already have funds in your Coinbase or Kraken account, go to the next step.",
      body: "EazyBot is a non-custodial company so you don't send them your money. Your Coinbase and/or Kraken accounts are where your trading money resides.",
      videos: [
        { title: "Add Funds — Coinbase", youtubeId: "_LD4TM-qPh4", thumbnail: "/covers/coinbase-cover.png" },
        { title: "Add Funds — Kraken",   youtubeId: "q_KitYjkth4", thumbnail: "/covers/kraken-cover.jpeg" },
      ],
    },
    {
      no: "04", icon: "link",
      title: "Connecting Your Accounts via API",
      body: "The API connection is how your EazyBot account communicates with your Coinbase or Kraken account. For security purposes, Coinbase and Kraken don't allow their customers to manage their API connections through cellular networks. You must use a computer.",
      videos: [
        { title: "API Connection — Coinbase", youtubeId: "qxr6mIbTAlg", thumbnail: "/covers/coinbase-cover.png" },
        { title: "API Connection — Kraken",   youtubeId: "e1d3U84JA5E", thumbnail: "/covers/kraken-cover.jpeg" },
      ],
    },
    {
      no: "05", icon: "rocket",
      title: "Start Your EazyBots",
      body: "Your EazyBots are engineered to run on autopilot, but we encourage you to join our online community and attend a few Zoom trainings to learn the details about how your digital employees earn income for you.",
      videos: [
        { title: "Starting Your EazyBots", youtubeId: null, thumbnail: "/covers/eazybot-cover.png" },
      ],
    },
    {
      no: "06", icon: "coins",
      title: "Add Funds to Your EazyBot Account",
      body: "These funds will be used to upgrade your EazyBot account to a paid subscription and pay for your initial SSF (Software Service Fees).",
      videos: [
        { title: "Adding Funds from Coinbase", youtubeId: "sdS7-J9VgfM", thumbnail: "/covers/step6-coinbase.png" },
        { title: "Adding Funds from Kraken",   youtubeId: "4qw7jVc-CB0", thumbnail: "/covers/step6-kraken.png" },
        { title: "Adding Funds from Uphold",   youtubeId: "VParMKzeEwg", thumbnail: "/covers/step6-uphold.png" },
        { title: "Adding Funds from PayPal",   youtubeId: null,          thumbnail: "/covers/step6-paypal.png" },
      ],
    },
    {
      no: "07", icon: "rocket",
      title: "Upgrade Your Subscription",
      body: "EazyBot gives you 30 days of free use to personally validate it's earning potential. When your free trial is over you'll keep access to your online portal, but you must upgrade to a paid subscription to continue earning income from your digital employees.",
      body2: "*Subscriptions start at $100/yr with no monthly payments.",
      body2Italic: true,
      videos: [
        { title: "Upgrade Your Subscription", youtubeId: null, thumbnail: "/covers/eazybot-cover.png" },
      ],
    },
  ],
  needHelp: {
    eyebrow: "GET EDUCATED",
    heading: "Join the SHYFT Coalition",
    body: "Our FREE Online Educational Community has all the support you need to maximize your EazyBot experience.",
    cta: { label: "Join Our Community", href: "https://shyftcoalition.com/?autojoin=1" },
  },
};
